import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider, Stack, Typography } from '@mui/material';
import StepLayout from '../../components/StepLayout/StepLayout';
import { useTunnelDispatch, useTunnelState } from '../../context/TunnelContext';
import { GUMS, SERVICES } from '../../utils/mockData';

export default function ShoeSummary() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();
  const { currentShoe, shoes } = useTunnelState();

  useEffect(() => {
    if (!currentShoe.service) {
      navigate('/nouvelle-demande/marque', { replace: true });
    }
    // Guard only the initial mount (e.g. a direct reload on this URL). It must
    // not re-run when this page's own actions clear currentShoe as part of a
    // deliberate navigation away, or it races that navigation and wins.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gumLabel = GUMS.find((gum) => gum.id === currentShoe.gum)?.label;
  const serviceLabel = SERVICES.find((service) => service.id === currentShoe.service)?.label;

  function handleAccept() {
    dispatch({ type: 'CONFIRM_CURRENT_SHOE' });
    navigate('/nouvelle-demande/coordonnees');
  }

  function handleAddAnother() {
    dispatch({ type: 'CONFIRM_CURRENT_SHOE' });
    navigate('/nouvelle-demande/marque');
  }

  function handleDecline() {
    dispatch({ type: 'RESET_ORDER' });
    navigate('/');
  }

  return (
    <StepLayout title="Récapitulatif de la paire">
      <Stack spacing={1} sx={{ maxWidth: 480, mb: 3 }}>
        <Typography>Marque : {currentShoe.brand}</Typography>
        {currentShoe.model && <Typography>Modèle : {currentShoe.model}</Typography>}
        <Typography>Pointure : {currentShoe.size}</Typography>
        <Typography>Gomme : {gumLabel}</Typography>
        <Typography>Service : {serviceLabel}</Typography>
      </Stack>

      {shoes.length > 0 && (
        <>
          <Divider sx={{ maxWidth: 480, mb: 2 }} />
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {shoes.length} paire(s) déjà ajoutée(s) à cette commande.
          </Typography>
        </>
      )}

      <Stack spacing={2} sx={{ maxWidth: 480 }}>
        <Button variant="contained" size="large" onClick={handleAccept}>
          Valider la commande
        </Button>
        <Button variant="outlined" size="large" onClick={handleAddAnother}>
          Ajouter une autre paire
        </Button>
        <Button variant="text" color="error" size="large" onClick={handleDecline}>
          Annuler
        </Button>
      </Stack>
    </StepLayout>
  );
}
